import { render, staticRenderFns } from "./EditDriverV2.vue?vue&type=template&id=abbd9d16&"
import script from "./EditDriverV2.vue?vue&type=script&lang=js&"
export * from "./EditDriverV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports